import(/* webpackMode: "eager" */ "/frontend/src/app/[lang]/[currency]/(chrome)/continent/[[...slug]]/ContinentPageClient.tsx")